import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Services() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: card1Ref, isVisible: card1Visible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: card2Ref, isVisible: card2Visible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section id="services" className="py-32 bg-[#1A2B4A]">
      <div className="max-w-7xl mx-auto px-8">
        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className="text-center mb-20"
          style={{
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? 'translateY(0)' : 'translateY(32px)',
            transition: 'opacity 0.7s ease, transform 0.7s ease',
          }}
        >
          <h2 className="text-5xl font-bold text-white mb-4">Para quién trabajamos</h2>
          <p className="text-xl text-white/60">Equilibrio entre empresas y profesionales</p>
        </div>

        <div className="space-y-10">
          {/* Para Empresas */}
          <div
            ref={card1Ref as React.RefObject<HTMLDivElement>}
            className="border border-white/15 rounded-xl p-12 hover:border-white/30 transition-all bg-white/5"
            style={{
              opacity: card1Visible ? 1 : 0,
              transform: card1Visible ? 'translateX(0)' : 'translateX(-56px)',
              transition: 'opacity 0.8s ease, transform 0.8s ease',
            }}
          >
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
              <div className="lg:col-span-3 flex justify-center">
                <div className="w-32 h-32 flex items-center justify-center bg-white/10 rounded-2xl">
                  <i className="ri-building-line text-6xl text-white/80"></i>
                </div>
              </div>
              <div className="lg:col-span-9">
                <h3 className="text-3xl font-bold text-white mb-8">Para empresas</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                  {[
                    'Selección de talento internacional cualificado',
                    'Análisis de cultura y necesidades',
                    'Encaje estratégico',
                    'Ahorro de tiempo y reducción de riesgo',
                    'Procesos confidenciales',
                  ].map((item) => (
                    <div key={item} className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-xl text-white/70 mt-1"></i>
                      <span className="text-white/80">{item}</span>
                    </div>
                  ))}
                </div>
                <a
                  href="#contact"
                  className="inline-flex items-center px-6 py-3 bg-white text-[#1A2B4A] text-sm font-semibold rounded-lg hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap group"
                >
                  Contratar talento
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Para Profesionales */}
          <div
            ref={card2Ref as React.RefObject<HTMLDivElement>}
            className="border border-white/15 rounded-xl p-12 hover:border-white/30 transition-all bg-white/5"
            style={{
              opacity: card2Visible ? 1 : 0,
              transform: card2Visible ? 'translateX(0)' : 'translateX(56px)',
              transition: 'opacity 0.8s ease 0.1s, transform 0.8s ease 0.1s',
            }}
          >
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
              <div className="lg:col-span-3 flex justify-center">
                <div className="w-32 h-32 flex items-center justify-center bg-white/10 rounded-2xl">
                  <i className="ri-briefcase-line text-6xl text-white/80"></i>
                </div>
              </div>
              <div className="lg:col-span-9">
                <h3 className="text-3xl font-bold text-white mb-8">Para profesionales</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                  {[
                    'Acompañamiento en colocación internacional',
                    'Orientación estratégica',
                    'Preparación para entrevistas',
                    'Seguimiento del proceso',
                    'Claridad y transparencia',
                  ].map((item) => (
                    <div key={item} className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-xl text-white/70 mt-1"></i>
                      <span className="text-white/80">{item}</span>
                    </div>
                  ))}
                </div>
                <a
                  href="#contact"
                  className="inline-flex items-center px-6 py-3 bg-white text-[#1A2B4A] text-sm font-semibold rounded-lg hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap group"
                >
                  Encontrar oportunidad
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
